// @flow
import * as api from "../data/firebase-data";
import * as actionTypes from "../constants/action-types";
import SupplyDistributionSite from "../models/supply-distribution-site";

/** EXAMPLE ACTIONS

 ***ASYNC EXAMPLE:

 export const doSomeAction = (foo): (any => void) => {
    function thunk(dispatch) {
        someAsyncFunction(foo)
            .then((result: mixed) => {
                dispatch({ type: actionTypes.SOME_ACTION_SUCCESS, payload: {result}});
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.SOME_ACTION_FAIL, payload: {error} });
            });
    }
    thunk.interceptOnOffline = true;
    return thunk;
};


 ***SYNCHRONOUS EXAMPLE:

 export const soSomeAction = (api: DataType): ActionType => (
 {
        type: actionTypes.SOME_ACTION,
        api
    }
 );

 **/


export const saveSupplyDistributionSite = (supplyDistributionSite: SupplyDistributionSite): (any=>void) => {
    function thunk(dispatch) {
        // eslint-disable-next-line no-unused-vars
        const { isDirty, ...mySupplyDistributionSite } = supplyDistributionSite; // strip isDirty from model
        if (mySupplyDistributionSite.id) {
            api.apiUpdateSupplyDistributionSite(mySupplyDistributionSite).then((result: mixed) => {
                dispatch({ type: actionTypes.SAVE_SUPPLY_DISTRIBUTION_SITE_SUCCESS, payload: { data: result } });
            })
                .catch((error: Error) => {
                    dispatch({ type: actionTypes.SAVE_SUPPLY_DISTRIBUTION_SITE_FAIL, payload: { error: error } });
                });

        } else {
            api.apiCreateSupplyDistributionSite(mySupplyDistributionSite).then((result: mixed) => {
                dispatch({ type: actionTypes.SAVE_SUPPLY_DISTRIBUTION_SITE_SUCCESS, payload: { data: result } });
            })
                .catch((error: Error) => {
                    dispatch({ type: actionTypes.SAVE_SUPPLY_DISTRIBUTION_SITE_FAIL, payload: { error: error } });
                });
        }
    }

    thunk.interceptOnOffline = true;
    return thunk;
};

export const deleteSupplyDistributionSite = (id: string): (any=>void) => {
    function thunk(dispatch) {
        api.apiDeleteSupplyDistributionSite({ id })
            .then((result: mixed) => {
                dispatch({ type: actionTypes.DELETE_SUPPLY_DISTRIBUTION_SITE_SUCCESS, payload: { data: result } });
            })
            .catch((error: Error) => {
                dispatch({ type: actionTypes.DELETE_SUPPLY_DISTRIBUTION_SITE_FAIL, payload: { error: error } });
            });
    }

    thunk.interceptOnOffline = true;
    return thunk;
};
